<template>
  <sidepanel
    id="panel-client-history"
    :wide="true"
    @open="init"
    :processing="processing"
    :title="'History'"
    @close="reset"
  >
    <div v-if="tests">
      <apexchart
        width="100%"
        type="line"
        :options="chartData.chartOptions"
        :series="chartData.series"
      ></apexchart>
      {{ markers }}
    </div>
  </sidepanel>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      processing: false,
      tests: null
    };
  },
  methods: {
    async init() {
      this.processing = true;
      const clientId = this.$store.getters.sidepanel("panel-client-history")
        .payload;
      this.tests = await this.$store.dispatch(
        "TestsStore/getByClient",
        clientId
      );
      this.processing = false;
    },
    reset() {
      this.tests = null;
    }
  },
  computed: {
    markers() {
      var data = {};
      const tests = this.tests.filter(test => test.status === "completed");
      tests.forEach(test => {
        data[test.created] = {};
        test.kit.markers.forEach(marker => {
          data[test.created][marker.id] = marker.value;
        });
      });
      return data;
    },
    chartData() {
      return {
        chartOptions: {
          chart: {
            id: "vuechart-example"
          },
          xaxis: {
            categories: Object.keys(this.markers)
          },
          stroke: {
            curve: "smooth"
          }
        },
        series: [
          {
            name: "b12",
            data: [30, 40, 35, 50]
          },
          {
            name: "dvit",
            data: [52, 32, 85, 103]
          }
        ]
      };
    }
  }
};
</script>

<style lang="less" scoped>
@import "../styles/vars";
</style>
